module.exports = __webpack_public_path__ + "23746744e1d3695b71c0dc4256ac3611.pdf";